import { t } from '@lingui/core/macro';
import { SystemDriverName } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export const getSystemDriverName = (driverName: SystemDriverName): string => {
    switch (driverName) {
        case 'pcb_width':
            return t`PCB width`;
        case 'pcb_height':
            return t`PCB height`;
        case 'pcb_thickness':
            return t`PCB thickness`;
        case 'pcb_layer_count':
            return t`PCB layer count`;
        case 'pcb_inner_copper_thickness':
            return t`PCB inner copper thickness`;
        case 'pcb_outer_copper_thickness':
            return t`PCB outer copper thickness`;
        case 'pcb_enig_thickness':
            return t`PCB ENIG thickness`;
        case 'panel_factor':
            return t`Panel factor`;
        case 'panel_width':
            return t`Panel width`;
        case 'panel_height':
            return t`Panel height`;
        case 'Sides_of_placement':
            return t`Sides of placement`;
        default:
            assertUnreachable(driverName);
    }
};
